
import ReportingAPIService from '@/modules/reporting/services/apiService'

export default class ReportingModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.reportingService = new ReportingAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }
}